<div class="row justify-content-center">
  <div class="col-12">
    <span class="visually-hidden" id="riskManagementStatusChartAriaLabel">
      {{ 'websites_apps_by_risk_management_status_description' | translate }}
    </span>
    <ds-link
      standalone="true"
      class="d-inline-flex"
      href="#websites-apps-by-risk-management-status-table"
      data-test-id="websites-apps-by-risk-management-status-table-link"
      (click)="openTableModal($event)"
    >
      <span class="visually-hidden">{{ 'view_websites_apps_by_risk_management_status_table' | translate }}</span>
      <span aria-hidden="true">{{ 'view_table_link' | translate }}</span>
    </ds-link>
    <div #chartHost id="riskManagementStatusChart" aria-hidden="true" class="graph w-100"></div>
  </div>
</div>
